module.exports = __webpack_public_path__ + "static/media/颜色分析模块.6ecc07f5.png";